import { IconDownload, IconFileTypePdf } from "@tabler/icons-react";
import Card from "./Card";
import styles from "../TalentProfile.module.css";
import Button from "../../../../components/UI/Button/button";

export default function ResumeCard({ talent }) {
  return (
    <Card
      icon={IconDownload}
      title="Download Resume"
      subtitle="Latest CV on file"
    >
      <div className={styles.resumeRow}>
        <div className={styles.resumeIconWrap}>
          <IconFileTypePdf size={24} />
        </div>
        <div className={styles.resumeInfo}>
          <div className={styles.resumeFilename}>
            {/* {initialsFor(talent.role)}_Resume_2024.pdf */}
            <span>{talent?.firstName} Resume</span>
          </div>
          <div className={styles.resumeMeta}>PDF · Updated recently</div>
        </div>
        <Button
          variant="navy"
          as="a"
          download
          target="_blank"
          rel="noopener noreferrer"
          href={talent?.pdfUrl}
          leftIcon={<IconDownload size={16} />}
        >
          Download
        </Button>
      </div>
    </Card>
  );
}
